export const RESET_SUPPLIERS = 'RESET_SUPPLIERS'
export const RESET_SUPPLIERS_SEARCH = 'RESET_SUPPLIERS_SEARCH'
export const SET_SUPPLIERS = 'SET_SUPPLIERS'
export const SET_SUPPLIERS_SEARCH = 'SET_SUPPLIERS_SEARCH'
